import * as yup from 'yup';
import { Authentification, ModificationMotDePasse } from '../entities';

export const schemaAuthentification = yup.object().shape<Authentification>({
    courriel: yup
        .string()
        .email('Ce champ doit contenir une adresse courriel valide')
        .required('Votre courriel est requis'),
    motDePasse: yup.string().required('Votre mot de passe est requis'),
});

export const schemaRecuperationMotDePasse = yup.object().shape<Authentification>({
    courriel: yup
        .string()
        .email('Ce champ doit contenir une adresse courriel valide')
        .required('Votre courriel est requis'),
});

/*export const schemaModificationMotDePasseProfile = yup.object().shape<ModificationMotDePasse>({
    ancientMotDePasse? : yup;
    nouveauMotDePasse: string;
    confrimationNouveauMDP?: string;
    courriel: yup
        .string()
        .email('Ce champ doit contenir une adresse courriel valide')
        .required('Votre courriel est requis'),
});*/

export const schemaModificationMotDePasseTemporaire = yup.object().shape<ModificationMotDePasse>({
    nouveauMotDePasse: yup
        .string()
        .required("Entrez votre nouveau mot de passe s'il vous plaît")
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
            'Devrait contenir au moins 8 Caracteres, une majuscule, une minuscule et un chiffre entre 0 et 9',
        ),
    confrimationNouveauMotDePasse: yup
        .string()
        .required("Confirmez votre nouveau mot de passe s'il vous plaît")
        .oneOf([yup.ref('nouveauMotDePasse'), null], 'Les mots de passe doivent correspondre'),
});
